import axios, { AxiosResponse } from 'axios'
import getConfig from 'config/web'

interface UserServiceClientResponseSuccess<T> {
    success: true
    data: T
}

interface UserServiceClientResponseError {
    success: false
    errorCode: string
}

export type UserServiceClientResponse<T> = UserServiceClientResponseSuccess<T> | UserServiceClientResponseError

// Client specifically for calls to the user service
const { userApiUrl: baseURL } = getConfig()

const userServiceClient = axios.create({
    baseURL,
    headers: {
        Accept: 'application/json',
    },
})

export default userServiceClient
